<div>
	<span translate>
		guarantee.request.submitted.successfully
	</span>
</div>
<div class="guarantee-follow-up">
	<span class="guarantee-follow-up-text" translate>
		guarantee.request.followup
	</span>
</div>